import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('apuracao', 'acordo');
const basePlanejamentoPath = getBasePath('planejamento', 'orcamento');

const relatorioAcordo = {
  pesquisar: { method: 'POST', url: `${basePath}` },
  pesquisarFiltroOrcamento: { method: 'GET', url: `${basePlanejamentoPath}/filtro-acordo` },
};

export default resource => resource(`${basePath}`, {}, relatorioAcordo);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/relatorioAcordo.js